<template>
  <div class="material-management">
    <!-- 已绑定辅料区域 -->
    <div class="material-head">
      <div class="title">已绑定辅料</div>
      <el-button type="primary" size="small" @click="openBindDialog">绑定辅料</el-button>
    </div>

    <!-- 已绑定辅料卡片列表 -->
    <div class="material-list" v-loading="listLoading">
      <div class="material-card" v-for="(item, index) in materialList" :key="item.id || index">
        <div class="material-img">
          <el-image v-if="item.main_image" :src="item.main_image" fit="cover" :preview-src-list="[item.main_image]" />
        </div>
        <div class="material-info">
          <div class="material-name">{{ item.name_trans || '-' }}</div>
          <div class="stock">库存数量：{{ item.material_stock_num || 0 }}</div>
          <div class="consume-row">
            <span>消耗：</span>
            <el-input v-model="item.consume" size="mini" class="consume-input" :disabled="!item.isEdit" />
            <span>点/套</span>
            <i class="el-icon-edit-outline edit-icon" v-if="!item.isEdit" @click="editConsume(item)"></i>
            <el-button v-else type="primary" size="mini" @click="saveConsume(item)">保存</el-button>
          </div>
        </div>
        <i class="el-icon-delete delete-icon" @click="deleteMaterial(index)"></i>
      </div>
      <div v-if="!materialList.length" class="empty">暂无绑定辅料</div>
    </div>

    <!-- 绑定辅料弹框 -->
    <el-dialog custom-class="bind-material-dialog" :visible.sync="bindDialogVisible" width="920px" append-to-body>
      <div slot="title" class="dialog-title">绑定辅料</div>

      <!-- 弹框搜索区 -->
      <div class="bind-search">
        <el-input v-model.trim="searchForm.name" placeholder="请输入辅料名称" clearable />
        <el-button type="primary" :loading="loading" @click="materialListSearch">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </div>

      <!-- 可绑定辅料卡片列表 -->
      <div class="bind-card-list" v-loading="loading">
        <div class="bind-card" v-for="item in bindList" :key="item.id" :class="{ selected: isSelected(item) }"
          @click="toggleSelect(item)">
          <el-checkbox class="bind-check" :value="isSelected(item)" @click.native.stop @change="toggleSelect(item)">
            辅料ID：{{ item.id || '-' }}
          </el-checkbox>
          <div class="bind-card-body">
            <div class="bind-img">
              <el-image v-if="item.main_image" :src="item.main_image" fit="cover"
                :preview-src-list="[item.main_image]" />
            </div>
            <div class="bind-info">
              <div class="bind-name">{{ item.name_trans || '-' }}</div>
              <div class="stock-status" :class="getStockClass(item)">{{ getStockText(item) }}</div>
              <div class="bind-line">类型：{{ item.type_name || (item.type && item.type.name) || '-' }}</div>
              <div class="bind-line">数量：{{ item.material_stock_num || 0 }}</div>
              <div class="bind-consume">
                <span>消耗：</span>
                <el-input v-model="item.consume" size="mini" @click.native.stop />
                <span>点/套</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!bindList.length && !loading" class="empty">暂无辅料</div>
      </div>

      <!-- 弹框底部操作 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmBind">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MaterialManagement',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentDetail: {},
      materialList: [],
      listLoading: false,
      bindDialogVisible: false,
      loading: false,
      bindList: [],
      selectedMaterialIds: [],
      searchForm: {
        name: ''
      }
    }
  },
  methods: {
    // 父页面切换到当前 tab 时会调用，用商品详情初始化已绑定辅料
    setData(data) {
      this.currentDetail = data || {}
      this.queryBindMaterialList()
    },
    // 打开绑定辅料弹框，并重置本次勾选状态
    openBindDialog() {
      this.selectedMaterialIds = []
      this.bindDialogVisible = true
      this.materialListSearch()
    },
    // 查询已绑定辅料列表
    queryBindMaterialList() {
      this.listLoading = true
      this.$api.productManagementApi.materialList(this.getMaterialParams()).then(res => {
        this.materialList = this.normalizeMaterialList(res)
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 查询可绑定辅料主档列表
    materialListSearch() {
      this.loading = true
      this.$api.warehouseApi.materialList({
        user_id: this.currentDetail.user_id || '',
        name: this.searchForm.name,
        page: 1,
        pageSize: 999
      }).then(res => {
        const data = res.data || {}
        this.bindList = (data.list || data.data || []).map(item => ({
          ...item,
          consume: item.consume || 1
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm.name = ''
      this.materialListSearch()
    },
    // 勾选或取消勾选辅料卡片
    toggleSelect(item) {
      const index = this.selectedMaterialIds.indexOf(item.id)
      if (index === -1) {
        this.selectedMaterialIds.push(item.id)
      } else {
        this.selectedMaterialIds.splice(index, 1)
      }
    },
    // 判断辅料是否已勾选
    isSelected(item) {
      return this.selectedMaterialIds.includes(item.id)
    },
    // 根据库存和预计消耗显示状态文案
    getStockText(item) {
      if (Number(item.material_stock_num || 0) < Number(item.pre_consume_num || 0)) {
        return '库存不足'
      }
      if (Number(item.pre_up_num || 0) > 0) {
        return '建议补货'
      }
      return '库存充足'
    },
    // 根据库存状态切换标签颜色
    getStockClass(item) {
      if (Number(item.material_stock_num || 0) < Number(item.pre_consume_num || 0)) {
        return 'danger'
      }
      if (Number(item.pre_up_num || 0) > 0) {
        return 'warning'
      }
      return 'success'
    },
    // 确认绑定本次勾选的辅料
    confirmBind() {
      const selectedList = this.bindList.filter(item => this.selectedMaterialIds.includes(item.id))
      if (!selectedList.length) {
        this.$message.warning('请选择辅料')
        return
      }

      const materialList = JSON.parse(JSON.stringify(this.materialList))
      selectedList.forEach(item => {
        if (!materialList.some(material => this.getMaterialId(material) === item.id)) {
          materialList.push({
            ...item,
            material_id: item.id,
            consume: item.consume || 1,
            isEdit: true
          })
        }
      })
      this.updateBindMaterialList(materialList).then(res => {
        this.bindDialogVisible = false
        this.$message.success(res.msg)
        this.queryBindMaterialList()
      }).catch(() => { })
    },
    // 点击编辑后允许修改消耗数量
    editConsume(item) {
      item.isEdit = true
    },
    // 保存当前辅料的消耗点数
    saveConsume(item) {
      this.updateBindMaterialList(this.materialList).then(res => {
        this.$message.success(res.msg)
        this.queryBindMaterialList()
      }).catch(() => { })
    },
    // 删除已绑定辅料
    deleteMaterial(index) {
      this.$confirm('确认删除该辅料吗？', '提示', {
        type: 'warning',
        center: true,
      }).then(() => {
        const materialList = JSON.parse(JSON.stringify(this.materialList))
        materialList.splice(index, 1)
        this.updateBindMaterialList(materialList).then(res => {
          this.$message.success(res.msg)
          this.queryBindMaterialList()
        }).catch(() => { })
      }).catch(() => { })
    },
    // 组装绑定辅料接口通用参数
    getMaterialParams() {
      const user_id = this.currentDetail.user_id || ''
      const sys_code = this.currentDetail.sys_code || (user_id && this.currentDetail.client_sku_code ? `${user_id}__${this.currentDetail.client_sku_code}` : '')
      return {
        user_id,
        sys_code,
      }
    },
    // 兼容接口返回的绑定辅料列表结构
    normalizeMaterialList(data) {
      const list = this.getResponseList(data)
      return list.map(item => {
        const material = item.material_detail || item.material || item.material_info || item.materialInfo || {}
        const material_id = this.getMaterialId(item)
        return {
          ...material,
          ...item,
          id: material_id,
          material_id,
          name_trans: this.getFirstValue([item.name_trans, material.name_trans]),
          main_image: this.getFirstValue([item.main_image, item.material_main_image, item.materialMainImage, item.image, item.pic, material.main_image, material.image, material.pic]),
          material_stock_num: this.getFirstValue([item.material_stock_num, material.material_stock_num, item.stock_num, item.stock, material.stock_num, material.stock], 0),
          consume: this.getFirstValue([item.consume, material.consume], 1),
          isEdit: false
        }
      })
    },
    // 获取第一个有效字段值
    getFirstValue(list, defaultValue = '') {
      const value = list.find(item => item !== undefined && item !== null && item !== '')
      return value !== undefined ? value : defaultValue
    },
    // 从接口返回中提取列表数据
    getResponseList(data) {
      if (!data) return []
      if (Array.isArray(data)) return data
      const listKeys = ['list', 'rows', 'data', 'material_list', 'materials', 'materialList', 'bind_list', 'bindList']
      for (let i = 0; i < listKeys.length; i++) {
        const value = data[listKeys[i]]
        if (Array.isArray(value)) return value
      }
      for (let i = 0; i < listKeys.length; i++) {
        const value = data[listKeys[i]]
        if (value && typeof value === 'object') {
          const list = this.getResponseList(value)
          if (list.length) return list
        }
      }
      return []
    },
    // 获取辅料主档ID
    getMaterialId(item) {
      return item.material_id || item.materialId || (item.material_detail && item.material_detail.id) || (item.material && item.material.id) || (item.material_info && item.material_info.id) || (item.materialInfo && item.materialInfo.id) || item.id
    },
    // 维护绑定辅料列表
    updateBindMaterialList(list) {
      for (let i = 0; i < list.length; i++) {
        if (!this.getMaterialId(list[i])) {
          this.$message.warning('辅料ID不能为空')
          return Promise.reject(new Error('material_id empty'))
        }
        if (!/^[1-9]\d*$/.test(String(list[i].consume))) {
          this.$message.warning('消耗数量必须是正整数')
          return Promise.reject(new Error('consume invalid'))
        }
      }
      const datas = {
        ...this.getMaterialParams(),
        list: list.map(item => ({
          material_id: this.getMaterialId(item),
          consume: item.consume
        }))
      }
      return this.$api.productManagementApi.materialUpdate(datas)
    }
  }
}
</script>

<style scoped lang="scss">
.material-management {
  min-height: 360px;
}

.material-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
}

.material-list {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.material-card {
  position: relative;
  display: flex;
  width: 455px;
  min-height: 110px;
  padding: 14px;
  border: 1px solid #DFDFDF;
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
}

.material-img {
  flex: 0 0 96px;
  width: 96px;
  height: 96px;
  margin-right: 14px;
  border-radius: 4px;
  background-color: #9B9B9B;
  overflow: hidden;

  .el-image {
    width: 100%;
    height: 100%;
  }
}

.material-info {
  flex: 1;
  min-width: 0;
  padding-right: 22px;
}

.material-name {
  line-height: 20px;
  margin-bottom: 10px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stock {
  margin-bottom: 10px;
  color: #333333;
}

.consume-row {
  display: flex;
  align-items: center;
  color: #333333;

  .consume-input {
    width: 70px;
    margin-right: 6px;
  }

  .edit-icon {
    margin-left: auto;
    color: #B4272D;
    cursor: pointer;
    font-size: 16px;
  }

  .el-button {
    margin-left: auto;
    background-color: #B4272D;
    border-color: #B4272D;
  }
}

.delete-icon {
  position: absolute;
  right: 14px;
  top: 14px;
  color: #B4272D;
  cursor: pointer;
  font-size: 16px;
}

.empty {
  width: 100%;
  height: 120px;
  line-height: 120px;
  text-align: center;
  color: #999999;
}

.dialog-title {
  font-weight: bold;
  color: #333333;
}

.bind-search {
  display: flex;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #EBEEF5;

  .el-input {
    width: 260px;
  }

  .el-button--primary {
    background-color: #B4272D;
    border-color: #B4272D;
  }
}

.bind-card-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  padding: 16px 0;
}

.bind-card {
  min-height: 166px;
  padding: 12px;
  border: 1px solid #E4E7ED;
  border-radius: 6px;
  background-color: #fff;
  box-sizing: border-box;
  cursor: pointer;

  &.selected {
    border-color: #F56C6C;
    background-color: #FFF7F7;
  }
}

.bind-check {
  margin-bottom: 10px;
}

.bind-card-body {
  display: flex;
}

.bind-img {
  flex: 0 0 86px;
  width: 86px;
  height: 86px;
  margin-right: 12px;
  border-radius: 4px;
  background-color: #9B9B9B;
  overflow: hidden;

  .el-image {
    width: 100%;
    height: 100%;
  }
}

.bind-info {
  flex: 1;
  min-width: 0;
}

.bind-name {
  margin-bottom: 8px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stock-status {
  display: inline-block;
  margin-bottom: 8px;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 12px;

  &.danger {
    color: #F56C6C;
    background-color: #FFF0F0;
  }

  &.warning {
    color: #E6A23C;
    background-color: #FDF6EC;
  }

  &.success {
    color: #15AD3C;
    background-color: #EEF9F0;
  }
}

.bind-line {
  margin-bottom: 8px;
  color: #333333;
}

.bind-consume {
  display: flex;
  align-items: center;
  color: #333333;

  .el-input {
    width: 78px;
    margin-right: 6px;
  }
}

.dialog-footer {
  text-align: center;

  .el-button--primary {
    background-color: #B4272D;
    border-color: #B4272D;
  }
}

/deep/ .bind-material-dialog {
  .el-dialog__header {
    padding: 12px 18px;

  }

  .el-dialog__body {
    padding: 16px 20px 0;
  }
}
</style>
